<script lang="ts">
	import type { MarkdownOptions, Renderers } from '@magidoc/plugin-svelte-marked';
	import type { Tokens, Token } from 'marked';
	import { twMerge } from 'tailwind-merge';
	import { decodeHtmlEntities } from '../../../../utils/decodeHtmlEntities/decodeHtmlEntities';
	import { Txt, type TxtVariant } from '../../../Txt';
	import { MarkdownImage } from '../MarkdownImage';
	import { MarkdownLink } from '../MarkdownLink';

	interface Props {
		tokens: Token[];
		variant?: TxtVariant;
		boldVariant?: TxtVariant;
		options?: MarkdownOptions | undefined;
		renderers?: Renderers | undefined;
		class?: string;
	}

	let {
		tokens,
		variant = 'body1',
		boldVariant = 'label2',
		options = undefined,
		renderers = undefined,
		...props
	}: Props = $props();

	const getImageToken = (_token: Token) => {
		return _token as Tokens.Image;
	};

	const getStrongToken = (_token: Token) => {
		return _token as Tokens.Strong;
	};

	const getTextToken = (_token: Token) => {
		return _token as Tokens.Paragraph;
	};

	const getCodespanToken = (_token: Token) => {
		return _token as Tokens.Codespan;
	};

	const getLinkToken = (_token: Token) => {
		return _token as Tokens.Link;
	};

	const getEmToken = (_token: Token) => {
		return _token as Tokens.Em;
	};
</script>

{#each tokens as _token}
	{#if _token.type === 'image'}
		<MarkdownImage token={getImageToken(_token)} />
	{:else if _token.type === 'strong'}
		<Txt component="span" variant={boldVariant} class={props.class}>
			{getStrongToken(_token).text}
		</Txt>
	{:else if _token.type === 'text'}
		{decodeHtmlEntities(getTextToken(_token).text)}
	{:else if _token.type === 'codespan'}
		<codespan>{getCodespanToken(_token).text}</codespan>
	{:else if _token.type === 'link'}
		<MarkdownLink
			{variant}
			class={props.class}
			token={getLinkToken(_token)}
			{options}
			{renderers}
		/>
	{:else if _token.type === 'em'}
		<Txt component="span" {variant} class={twMerge('italic', props.class)}>
			{getEmToken(_token).text}
		</Txt>
	{:else if _token.type === 'html' && _token.raw === '<br>'}
		<br />
		<!-- A markdown hard break (a line ending in two spaces) lexes to its own
		`br` token, not to raw html — without this it would vanish. -->
	{:else if _token.type === 'br'}
		<br />
	{/if}
{/each}
